export default __webpack_public_path__ + "logo-appstore-it-84c4835d5739936e8fabf1c0406dfffb.svg";